import { Injectable } from '@angular/core';
import { PortalStorageService } from '.';
import { AuthService } from '../domain/auth';
import { NavigationItem } from '../../theme/layout/admin/navigation/navigation';
import { PortalUserDto } from '../domain/admin/models/portalUserDto';
import { AdminService } from '../domain/admin/services/admin.service';
import { MenuGroup, MenuItem, MenuType } from '../helpers/enum/menu.enums';
import { setNavGroupsToHide } from '../helpers/role/role-helper';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { LoggerService } from './logger.service';

@Injectable({
    providedIn: 'root',
})
export class NavService {
    public portalUser: PortalUserDto;
    public navigation: any;
    public navigationSubject = new Subject<any>();

    constructor(
        private nav: NavigationItem,
        private adminService: AdminService,
        private authService: AuthService,
        private router: Router,
        private customLogger: LoggerService,
        private storageService: PortalStorageService,
    ) {
        this.navigation = this.nav.get();
    }

    // get employee from storage or api
    async setUserProfileAsync(): Promise<void> {
        await this.adminService.getPortalUserLoggedinAsync();
        this.portalUser = this.adminService.portalUser;
    }

    //hide menu based on employee roles
    setNavigation(user: PortalUserDto): void {
        const storedMenu = this.storageService.getMenu();
        if (storedMenu != null && storedMenu.length > 0) {
            this.navigation = storedMenu;
        } else {
            this.navigation = this.nav.get();
        }
        //TODO: groups, items and subitems must come from api
        const navToHide = setNavGroupsToHide(user);
        const navItemsToHide: MenuItem[] = navToHide.menuItems;
        this.navigation = this.navigation.filter((x) => !navItemsToHide.includes(x.id));
        this.storageService.saveMenu(this.navigation);
        this.navigationSubject.next(this.navigation);
    }

    authenticateUserRoute(): void {
        setTimeout(() => {
            const storedUser = this.storageService.getUser();
            if (storedUser !== null) {
                if (storedUser.vendor) {
                    if (
                        (storedUser.canScheduleCase != null && storedUser.canScheduleCase) ||
                        (storedUser.canConfirmCase != null && storedUser.canConfirmCase)
                    ) {
                        this.customLogger.info('RoleGuard: Default User -- redirecting to home page');
                        this.router.navigate(['/dashboard/dash-customer']);
                    } else {
                        this.customLogger.info('RoleGuard: Vendor -- redirecting to vendor report page');
                        this.router.navigate(['/vendor/reports']);
                    }
                } else {
                    this.customLogger.info('RoleGuard: Default User -- redirecting to home page');
                    this.router.navigate(['/dashboard/dash-customer']);
                }
                this.setNavigation(storedUser);
            }
        }, 200);
    }

    clearLocalStorage(): void {
        this.storageService.clearLocalStorage();
    }
}
